export default "__VITE_ASSET__MYaJNb7L__"